module.exports = __webpack_public_path__ + "images/fa-hero-testimonials-page-reviews.webp";